<template>
  <v-card outlined>
    <v-card-title class="d-flex justify-space-between">
      <div>Cài đặt lương và thuế TNCN</div>
      <v-btn @click="onSave" :disabled="!isDataChanged" depressed color="primary">Lưu</v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <div class="mb-4">
        <div>Cài đặt lương <span class="red--text">(*)</span></div>
        <v-checkbox v-model="salaryConfig" label="Đóng bảo hiểm tại trường" value="core" hide-details />
        <v-checkbox v-model="salaryConfig" label="Có sổ hưu" value="pension" hide-details />
        <v-checkbox
          v-model="salaryConfig"
          label="Trích 10% lương để hoàn thành thủ tục"
          value="freelance"
          hide-details
        />
      </div>
      <div>
        <div>Cài đặt giảm thuế TNCN</div>
        <!-- <v-checkbox v-model="reduceOnSelf" label="Giảm trừ bản thân" :value="true" hide-details /> -->
        <v-checkbox v-model="reduceOnDependency" label="Giảm trừ người phụ thuộc" :value="true" hide-details />
        <div class="mt-3" style="width: 300px;">
          <v-text-field
            hide-details
            v-if="reduceOnDependency"
            v-model="numberOfDependencies"
            label="Số người phụ thuộc"
            required
            type="number"
            outlined
            dense
          />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { get } from 'lodash'
export default {
  data() {
    return {
      salaryConfig: '',
      // reduceOnSelf: false, // no need as it is calculated based on salary-config
      reduceOnDependency: false,
      numberOfDependencies: 0,
      isDataChanged: false
    }
  },
  computed: {
    ...mapState('teacher', ['teacher'])
  },
  methods: {
    ...mapActions({
      updateTeacher: 'teacher/updateTeacher'
    }),
    async onSave() {
      this.isDataChanged = false
      const isValid = this.validateTaxReductionPolicy()
      if (isValid) {
        await this.updateTeacher({
          id: this.teacher.id,
          salaryConfig: this.salaryConfig,
          taxReductionConfig: {
            // reduceOnSelf: this.reduceOnSelf,
            reduceOnDependency: this.reduceOnDependency,
            numberOfDependencies: this.numberOfDependencies
          }
        })
      }
    },
    validateTaxReductionPolicy() {
      if (this.reduceOnDependency) {
        if (this.numberOfDependencies < 1) {
          this.$alert.error('Số người phụ thuộc phải lớn hơn 0!')
          return false
        }
      }
      if (this.salaryConfig.length < 1) {
        this.$alert.error('Vui lòng chọn Cài đặt lương')
        return false
      }
      return true
    },
    handleDataChanged(val, oldVal) {
      if (val !== oldVal) this.isDataChanged = true
    }
  },
  watch: {
    teacher: {
      handler(val) {
        this.salaryConfig = val.salaryConfig ? val.salaryConfig : ''
        this.reduceOnDependency = get(val, 'taxReductionConfig.reduceOnDependency', false)
        this.reduceOnSelf = get(val, 'taxReductionConfig.reduceOnSelf', false)
        this.numberOfDependencies = get(val, 'taxReductionConfig.numberOfDependencies', 0)
      },
      immediate: true,
      deep: true
    },
    salaryConfig: {
      handler(val, oldVal) {
        this.handleDataChanged(val, oldVal)
      }
    },
    reduceOnSelf: {
      handler(val, oldVal) {
        this.handleDataChanged(val, oldVal)
      }
    },
    reduceOnDependency: {
      handler(val, oldVal) {
        this.handleDataChanged(val, oldVal)
      }
    },
    numberOfDependencies: {
      handler(val, oldVal) {
        this.handleDataChanged(val, oldVal)
      }
    }
  }
}
</script>
